import { NodeRepeatNotificationDTO, RepeatAlertSettings } from '.';

export enum REPEAT_ALERT {
    // GET_IS_DELEGATED_REQUEST = 'REPEAT_ALERT.GET_IS_DELEGATED_REQUEST',
    // GET_IS_DELEGATED_SUCCESS = 'REPEAT_ALERT.GET_IS_DELEGATED_SUCCESS',
    // GET_IS_DELEGATED_FAILURE = 'REPEAT_ALERT.GET_IS_DELEGATED_FAILURE',

    GET_NODE_SETTINGS_REQUEST = 'REPEAT_ALERT.GET_NODE_SETTINGS_REQUEST',
    GET_NODE_SETTINGS_SUCCESS = 'REPEAT_ALERT.GET_NODE_SETTINGS_SUCCESS',
    GET_NODE_SETTINGS_FAILURE = 'REPEAT_ALERT.GET_NODE_SETTINGS_FAILURE',

    SET_NODE_SETTINGS_REQUEST = 'REPEAT_ALERT.SET_NODE_SETTINGS_REQUEST',
    SET_NODE_SETTINGS_SUCCESS = 'REPEAT_ALERT.SET_NODE_SETTINGS_SUCCESS',
    SET_NODE_SETTINGS_FAILURE = 'REPEAT_ALERT.SET_NODE_SETTINGS_FAILURE',

    SET_SETTINGS = 'REPEAT_ALERT.SET_SETTINGS',
    CHANGE_SELECTED = 'REPEAT_ALERT.CHANGE_SELECTED',
    CHANGE_NODES_FOR_REPEAT_OPENED = 'REPEAT_ALERT.CHANGE_NODES_FOR_REPEAT_OPENED',
    REPLACE_NODES_FOR_REPEAT_OPENED = 'REPEAT_ALERT.REPLACE_NODES_FOR_REPEAT_OPENED',
    SET_NODE_SETTINGS_SUCCESS_By_Sockets = 'REPEAT_ALERT.SET_NODE_SETTINGS_SUCCESS_By_Sockets',
}

export interface IGetRepeatSettingsRequest {
    type: typeof REPEAT_ALERT.GET_NODE_SETTINGS_REQUEST;
}

export interface IGetRepeatSettingsSuccess {
    type: typeof REPEAT_ALERT.GET_NODE_SETTINGS_SUCCESS;
    payload: any;
}

export interface IGetRepeatSettingsFailure {
    type: typeof REPEAT_ALERT.GET_NODE_SETTINGS_FAILURE;
}

export interface ISetRepeatSettingsRequest {
    type: typeof REPEAT_ALERT.SET_NODE_SETTINGS_REQUEST;
    payload: NodeRepeatNotificationDTO;
}

export interface ISetRepeatSettingsSuccess {
    type: typeof REPEAT_ALERT.SET_NODE_SETTINGS_SUCCESS;
    payload: NodeRepeatNotificationDTO;
}
export interface ISetRepeatSettingsBySockets {
    type: typeof REPEAT_ALERT.SET_NODE_SETTINGS_SUCCESS_By_Sockets;
    payload: NodeRepeatNotificationDTO;
}
export interface ISetRepeatSettingsFailure {
    type: typeof REPEAT_ALERT.SET_NODE_SETTINGS_FAILURE;
    payload: any;
}

export interface IRepeatAlertSettings {
    type: typeof REPEAT_ALERT.SET_SETTINGS;
    payload: RepeatAlertSettings;
}
export interface IChangeRepeatAlertSelected {
    type: typeof REPEAT_ALERT.CHANGE_SELECTED;
    payload: number;
}
export interface IChangeNodesRepeatOpened {
    type: typeof REPEAT_ALERT.CHANGE_NODES_FOR_REPEAT_OPENED;
    payload: { value: number[]; isOpen: boolean };
}

export interface IReplaceNodesRepeatOpened {
    type: typeof REPEAT_ALERT.REPLACE_NODES_FOR_REPEAT_OPENED;
    payload: { value: number[]; isOpen: boolean };
}
export type RepeatAlertActionType =
    | IGetRepeatSettingsSuccess
    | IGetRepeatSettingsRequest
    | IGetRepeatSettingsFailure
    | ISetRepeatSettingsSuccess
    | ISetRepeatSettingsRequest
    | ISetRepeatSettingsFailure
    | IRepeatAlertSettings
    | IChangeRepeatAlertSelected
    | IReplaceNodesRepeatOpened
    | IChangeNodesRepeatOpened
    | ISetRepeatSettingsBySockets;
